export default __webpack_public_path__ + "static/media/whatsapp.56e45a64.svg";